export const envBasics = {
    production: false,
    apiEndpoint: 'http://tsned.localhost:81/',
    isApp: false,
    development: false,
    azureWorkItemUrl: 'https://dev.azure.com/codalt/TSNed/_workitems/edit/',
    googleMapsKey: 'AIzaSyBDvXGNcqH1tWNCwwzDThOmG3ihggdmoUk',
};
